export const removeVersionFromEndpoint = (endpoint) => {
  const versionMatch = endpoint.match(/\/v[0-9]$/)
  if (versionMatch) {
    return endpoint.replace(versionMatch[0], '')
  }
  return endpoint
}
